/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ZipIcon = createIcon("ZipIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#EBAD00';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 14h4a2 2 0 002-2V8a2 2 0 00-2-2h-4a2 2 0 00-2 2v4a2 2 0 002 2Zm0 10h4a2 2 0 002-2v-4a2 2 0 00-2-2h-4a2 2 0 00-2 2v4a2 2 0 002 2Zm1.98 6c-.482 0-.928.17-1.278.461a1.992 1.992 0 00-.687 1.163l-1.133 6.375 6.287-.06-1.183-6.308a1.975 1.975 0 00-.688-1.165A2.06 2.06 0 0023.98 30Zm-3.832-2.617A5.993 5.993 0 0123.98 26a6.06 6.06 0 013.863 1.38 5.974 5.974 0 012.075 3.514l1.194 6.369a3.994 3.994 0 01-.63 2.996 3.993 3.993 0 01-2.28 1.609l-.242.063-7.14.07a3.994 3.994 0 01-2.829-1.173 3.994 3.994 0 01-1.16-2.537l-.019-.249 1.27-7.148a5.993 5.993 0 012.066-3.511Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.ZipIcon",
  "replaceColor": true
});